import { jsx } from "panel";
import { ModalEl } from "common/components/modal";
import { BrowseEl } from "common/widgets/browse";
import { SearchInputEl } from "common/widgets/search-input";
import { InputTheme } from "common/components/input/types";
export function template() {
  const { searchedText } = this.state;
  return /* @__PURE__ */ jsx("div", {
    sel: ".load-entity-modal"
  }, this.attr(`open`) ? /* @__PURE__ */ jsx(ModalEl, {
    sel: ".modal.load-entity-modal",
    attrs: {
      closeable: true,
      open: this.attr(`open`),
      "grow-to-content": true,
      elref: `loadModal`
    },
    on: { change: this.handleLoadModalStateChange }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".modal-inner-wrapper"
  }, /* @__PURE__ */ jsx(BrowseEl, {
    attrs: { elref: `browse` },
    params: {
      entityTypeFilter: this.attr(`entity-type-filter`),
      mode: this.attr(`mode`),
      projectId: parseInt(this.attr(`project-id`), 10),
      userId: this.attr(`user-id`),
      searchText: this.state.searchedText,
      onRedirectToEntity: () => {
        this.triggerCloseModal();
      },
      onSelect: (result) => {
        const event = new CustomEvent(`select`, { detail: result });
        this.dispatchEvent(event);
      },
      onSearchUpdated: ({ trackingProps }) => {
        this.update({ resultsTrackingProperties: trackingProps });
      },
      headerContent: /* @__PURE__ */ jsx(SearchInputEl, {
        params: {
          searchedText,
          onSearchedTextUpdate: (text) => this.handleSearchedTextUpdated(text),
          theme: InputTheme.Default,
          placeholder: `Browse by Title or Creator...`
        },
        attrs: { elref: `searchInputCmp` }
      })
    }
  }))) : null);
}
